import { render, staticRenderFns } from "./noCoursePage.vue?vue&type=template&id=b1732d5e&scoped=true"
import script from "./noCoursePage.vue?vue&type=script&lang=js"
export * from "./noCoursePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1732d5e",
  null
  
)

export default component.exports